import { render, staticRenderFns } from "./RetrieveApplicant.vue?vue&type=template&id=879d32f4&"
import script from "./RetrieveApplicant.vue?vue&type=script&lang=js&"
export * from "./RetrieveApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports